var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShip3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 179,
    viewBox: "0 0 35 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.232422 33.1506V151.228C0.232422 159.782 3.95348 164.092 3.95348 164.092H30.8888C30.8888 164.092 34.6098 159.782 34.6098 151.228V33.1506C34.6098 3.61939 17.4211 0 17.4211 0C17.4211 0 0.232422 3.61939 0.232422 33.1506Z",
    fill: "#0047E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39102 23.4102C2.91656 26.0942 2.63867 38.7078 2.63867 42.1781H32.2038C32.2038 38.7078 31.9259 26.0942 31.4514 23.4102H3.39102Z",
    fill: "#5D3E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50488 12.1188H27.3302C23.0194 5.27994 17.4141 4.10059 17.4141 4.10059C17.4141 4.10059 11.8088 5.27994 7.50488 12.1188Z",
    fill: "#5D3E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2038 42.1787H2.63867V153.458H32.2038V42.1787Z",
    fill: "#694B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4957 62.1602H4.33984V133.484H30.4957V62.1602Z",
    fill: "#D2D0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8414 133.815H4.00098V61.8135H30.8346V133.815H30.8414ZM4.68554 133.137H30.1636V62.4913H4.67876V133.137H4.68554Z",
    fill: "#FF2312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95312 164.086C3.95312 164.086 12.4594 177.994 17.4208 178.841C22.3754 179.689 30.8884 164.086 30.8884 164.086H3.95312Z",
    fill: "#0047E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63867 153.458C2.63867 153.458 8.7591 171.48 17.4212 171.48C25.0734 171.48 31.0176 158.582 32.2038 153.458H2.63867Z",
    fill: "#694B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5886 78.7734H9.26074V124.646H25.5886V78.7734Z",
    fill: "#F2F0D7",
    stroke: "#9D9D9C",
    strokeWidth: 0.677788,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3515 103.004H11.4834V121.223H23.3515V103.004Z",
    fill: "#FCFAEB",
    stroke: "#B2B2B2",
    strokeWidth: 0.677788,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4207 155.986C18.817 155.986 19.9489 154.854 19.9489 153.458C19.9489 152.062 18.817 150.93 17.4207 150.93C16.0245 150.93 14.8926 152.062 14.8926 153.458C14.8926 154.854 16.0245 155.986 17.4207 155.986Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4207 144.905C18.817 144.905 19.9489 143.773 19.9489 142.377C19.9489 140.981 18.817 139.849 17.4207 139.849C16.0245 139.849 14.8926 140.981 14.8926 142.377C14.8926 143.773 16.0245 144.905 17.4207 144.905Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4207 40.8639C18.817 40.8639 19.9489 39.732 19.9489 38.3358C19.9489 36.9395 18.817 35.8076 17.4207 35.8076C16.0245 35.8076 14.8926 36.9395 14.8926 38.3358C14.8926 39.732 16.0245 40.8639 17.4207 40.8639Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4207 29.7819C18.817 29.7819 19.9489 28.65 19.9489 27.2537C19.9489 25.8575 18.817 24.7256 17.4207 24.7256C16.0245 24.7256 14.8926 25.8575 14.8926 27.2537C14.8926 28.65 16.0245 29.7819 17.4207 29.7819Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0943 99.1807H11.7549V101.072H23.0943V99.1807Z",
    stroke: "#B2B2B2",
    strokeWidth: 0.677788,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0943 94.3887H11.7549V96.2797H23.0943V94.3887Z",
    stroke: "#B2B2B2",
    strokeWidth: 0.677788,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0943 90.1328H11.7549V92.0238H23.0943V90.1328Z",
    stroke: "#B2B2B2",
    strokeWidth: 0.677788,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96945 135.781H5.22754V138.16H6.96945V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55344 44.584H3.81152V46.963H5.55344V44.584Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55344 48.5967H3.81152V50.9757H5.55344V48.5967Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55344 52.7783H3.81152V55.1574H5.55344V52.7783Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3698 44.5029H29.6279V46.882H31.3698V44.5029Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3698 48.5156H29.6279V50.8947H31.3698V48.5156Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3698 52.6973H29.6279V55.0763H31.3698V52.6973Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80246 135.781H8.06055V138.16H9.80246V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6286 135.781H10.8867V138.16H12.6286V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4626 135.781H13.7207V138.16H15.4626V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2956 135.781H16.5537V138.16H18.2956V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1218 135.781H19.3799V138.16H21.1218V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9548 135.781H22.2129V138.16H23.9548V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.781 135.781H25.0391V138.16H26.781V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.615 135.781H27.873V138.16H29.615V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00103 40.836C4.37536 40.836 4.67882 40.5326 4.67882 40.1583C4.67882 39.7839 4.37536 39.4805 4.00103 39.4805C3.6267 39.4805 3.32324 39.7839 3.32324 40.1583C3.32324 40.5326 3.6267 40.836 4.00103 40.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00103 36.1671C4.37536 36.1671 4.67882 35.8636 4.67882 35.4893C4.67882 35.115 4.37536 34.8115 4.00103 34.8115C3.6267 34.8115 3.32324 35.115 3.32324 35.4893C3.32324 35.8636 3.6267 36.1671 4.00103 36.1671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48931 29.7745C4.86364 29.7745 5.1671 29.4711 5.1671 29.0967C5.1671 28.7224 4.86364 28.4189 4.48931 28.4189C4.11498 28.4189 3.81152 28.7224 3.81152 29.0967C3.81152 29.4711 4.11498 29.7745 4.48931 29.7745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9229 40.836C31.2972 40.836 31.6007 40.5326 31.6007 40.1583C31.6007 39.7839 31.2972 39.4805 30.9229 39.4805C30.5486 39.4805 30.2451 39.7839 30.2451 40.1583C30.2451 40.5326 30.5486 40.836 30.9229 40.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9229 36.1671C31.2972 36.1671 31.6007 35.8636 31.6007 35.4893C31.6007 35.115 31.2972 34.8115 30.9229 34.8115C30.5486 34.8115 30.2451 35.115 30.2451 35.4893C30.2451 35.8636 30.5486 36.1671 30.9229 36.1671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4346 29.7745C30.809 29.7745 31.1124 29.4711 31.1124 29.0967C31.1124 28.7224 30.809 28.4189 30.4346 28.4189C30.0603 28.4189 29.7568 28.7224 29.7568 29.0967C29.7568 29.4711 30.0603 29.7745 30.4346 29.7745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00103 141.61C4.37536 141.61 4.67882 141.307 4.67882 140.933C4.67882 140.558 4.37536 140.255 4.00103 140.255C3.6267 140.255 3.32324 140.558 3.32324 140.933C3.32324 141.307 3.6267 141.61 4.00103 141.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00103 146.28C4.37536 146.28 4.67882 145.977 4.67882 145.603C4.67882 145.228 4.37536 144.925 4.00103 144.925C3.6267 144.925 3.32324 145.228 3.32324 145.603C3.32324 145.977 3.6267 146.28 4.00103 146.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48931 152.672C4.86364 152.672 5.1671 152.369 5.1671 151.994C5.1671 151.62 4.86364 151.316 4.48931 151.316C4.11498 151.316 3.81152 151.62 3.81152 151.994C3.81152 152.369 4.11498 152.672 4.48931 152.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9229 141.61C31.2972 141.61 31.6007 141.307 31.6007 140.933C31.6007 140.558 31.2972 140.255 30.9229 140.255C30.5486 140.255 30.2451 140.558 30.2451 140.933C30.2451 141.307 30.5486 141.61 30.9229 141.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9229 146.28C31.2972 146.28 31.6007 145.977 31.6007 145.603C31.6007 145.228 31.2972 144.925 30.9229 144.925C30.5486 144.925 30.2451 145.228 30.2451 145.603C30.2451 145.977 30.5486 146.28 30.9229 146.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4346 152.672C30.809 152.672 31.1124 152.369 31.1124 151.994C31.1124 151.62 30.809 151.316 30.4346 151.316C30.0603 151.316 29.7568 151.62 29.7568 151.994C29.7568 152.369 30.0603 152.672 30.4346 152.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4282 41.541H17.4215C11.7915 41.541 7.22754 46.105 7.22754 51.7349V61.0477C7.22754 66.6777 11.7915 71.2417 17.4215 71.2417H17.4282C23.0582 71.2417 27.6222 66.6777 27.6222 61.0477V51.7349C27.6222 46.105 23.0582 41.541 17.4282 41.541Z",
    fill: "#191514",
    stroke: "#0047E5",
    strokeWidth: 1.35558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7534 73.3643H17.7467C12.1167 73.3643 7.55273 77.9282 7.55273 83.5582V92.871C7.55273 98.5009 12.1167 103.065 17.7467 103.065H17.7534C23.3834 103.065 27.9474 98.5009 27.9474 92.871V83.5582C27.9474 77.9282 23.3834 73.3643 17.7534 73.3643Z",
    fill: "#191514",
    stroke: "#0047E5",
    strokeWidth: 1.35558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7534 105.051H17.7467C12.1167 105.051 7.55273 109.615 7.55273 115.245V124.558C7.55273 130.187 12.1167 134.751 17.7467 134.751H17.7534C23.3834 134.751 27.9474 130.187 27.9474 124.558V115.245C27.9474 109.615 23.3834 105.051 17.7534 105.051Z",
    fill: "#191514",
    stroke: "#0047E5",
    strokeWidth: 1.35558,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.3774,
    height: 178.875,
    fill: "white",
    transform: "translate(0.232422)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip3);
export default __webpack_public_path__ + "static/media/ship-3.svg";
export { ForwardRef as ReactComponent };